import { sidebarItemConfig } from '@/core/app-shell/sidebar/sidebarItemConfig.ts'

export const explorerNodesConfig = {
  levelIndent: 1.5,
  iconSize: sidebarItemConfig.iconSize,
  nodeHeightPx: sidebarItemConfig.iconSize,
  iconSx: sidebarItemConfig.iconSx,
  nodeSx: sidebarItemConfig.itemSx,
}
